import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { NavigationDataKey } from '@shared-libs/enums';
import { NavigationDataManager } from '@app/modules/shared/managers/navigation-data.manager';

/**
 * @description A guard that checks if needed data is set in the navigationDataManager.
 * In a route guard we have to pass a data object to the route (in the app-routing.module) with the params as properties
 * @param navigationDataKey - The navigation-data key that should be set
 * @param redirect - The route to redirect to when the navigation-data is not set
 */

@Injectable({
	providedIn: 'root',
})
export class ParamGuard {
	constructor(
		public readonly router: Router,
		public readonly navigationDataManager: NavigationDataManager
	) {}

	/**
	 * Overridden Angular function that contains guard logic and handles when it's not compliant
	 * @param {ActivatedRouteSnapshot} route The activated route
	 * @param {RouterStateSnapshot} _state The router
	 * @returns {boolean} Whether the correct data is set or not
	 */
	canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
		const navigationDataKeys: Array<NavigationDataKey> = route.data.navigationDataKey;
		const redirect: string = route.data.redirect;
		if (navigationDataKeys.some((key) => this.navigationDataManager.dataIsSet(key))) return true;
		void this.router.navigate([redirect]).catch();
		return false;
	}
}
